import cx from 'classnames'
import type { ReactNode } from 'react'
import styles from './Emphasize.module.css'

export interface EmphasizeProps {
  children?: ReactNode
  bold?: boolean
}

/**
 * Emphasized text within a sentence.
 */
export function Emphasize({ children, bold }: EmphasizeProps) {
  return (
    <span className={cx(styles.root, bold && styles.bold)}>{children}</span>
  )
}
